import i18n from "../../../i18n";
import React from "react";
import {
  Text,
  Title,
  Badge,
  Stack,
  Group,
  Grid,
  Switch,
  Tooltip,
  Anchor,
} from "@mantine/core";
import moment from "moment";
import { incentiveTypeBadge } from "../../../data/options";

const ByIncentiveRowHeader = ({
  item,
  formatter,
  onHold,
  loading,
  isConfirmed,
}) => {
  const heldCount =
    item.holdCount ??
    item.bids?.filter((b) => b.status === "HOLD").length ??
    0;
  const isAllHeld = heldCount === item.bidCount && item.bidCount > 0;

  const getSourceId = () => {
    if (item.incentive?._id) return item.incentive._id;
    return item.key;
  };

  return (
    <Grid justify="space-between" align="center">
      <Grid.Col span={5}>
        <Stack spacing={4}>
          <Group spacing="xs">
            <Badge
              size="sm"
              color={incentiveTypeBadge(item.incentive?.incentiveType).color}
              variant="light"
            >
              {incentiveTypeBadge(item.incentive?.incentiveType).label}
            </Badge>
            {item.incentive ? (
              <Anchor
                href={`/m/account/incentive?id=${item.incentive._id}&mode=edit`}
                target="_blank"
                size="sm"
                weight={500}
              >
                {item.incentive.code}
              </Anchor>
            ) : (
              <Text size="sm" weight={500}>
                {item.code || "Unknown"}
              </Text>
            )}
            {heldCount > 0 && (
              <Badge size="xs" color="yellow" variant="filled">
                {heldCount} held
              </Badge>
            )}
          </Group>
          {item.incentive?.title && (
            <Group spacing="xs">
              <Text size="xs" color="dimmed">
                Title:
              </Text>
              <Text size="xs" weight={500}>
                {item.incentive.title}
              </Text>
            </Group>
          )}
          {item.incentive?.consultant && (
            <Group spacing="xs">
              <Text size="xs" color="dimmed">
                Consultant:
              </Text>
              <Text size="xs" weight={500}>
                {item.incentive.consultant.name ||
                  item.incentive.consultant.cname}
              </Text>
              {item.incentive.consultant.staffId && (
                <Badge size="xs" variant="outline" color="gray">
                  {item.incentive.consultant.staffId}
                </Badge>
              )}
            </Group>
          )}
          {item.incentive?.issueDate && (
            <Group spacing="xs">
              <Text size="xs" color="dimmed">
                Issue Date:
              </Text>
              <Text size="xs">
                {moment(item.incentive.issueDate).format("YYYY-MM-DD")}
              </Text>
            </Group>
          )}
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <Stack align="flex-start" spacing="xs">
          <Title order={3}>{item.bidCount}</Title>
          <Text size="xs" color="dimmed">
            Total bids
          </Text>
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <Stack align="flex-start" spacing="xs">
          <Title order={3} color={item.totalAmount >= 0 ? "green" : "red"}>
            {formatter.currency(item.totalAmount)}
          </Title>
          <Text size="xs" color="dimmed">{i18n.t("Total Amount")}</Text>
        </Stack>
      </Grid.Col>
      <Grid.Col span={2}>
        <div onClick={(e) => e.stopPropagation()}>
          <Tooltip
            label={
              isConfirmed
                ? "Payroll completed"
                : isAllHeld
                  ? "Release all bids"
                  : "Hold all bids"
            }
          >
            <Switch
              size="md"
              color="yellow"
              checked={isAllHeld}
              disabled={loading || isConfirmed}
              onChange={(e) =>
                onHold && onHold(getSourceId(), "INCENTIVE", !isAllHeld)
              }
              label={
                <Text size="xs" color="dimmed">{i18n.t("Hold")}</Text>
              }
            />
          </Tooltip>
        </div>
      </Grid.Col>
    </Grid>
  );
};

export default ByIncentiveRowHeader;
